var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9.91667V9.91667H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 0H21.25V9.91667H11.3333V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5833 0H22.6667V9.91667H32.5833V0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3333H9.91667V21.25H0V11.3333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 11.3333H11.3333V21.25H12.8504C13.4717 16.9069 16.9069 13.4717 21.25 12.8504V11.3333Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4829 21.25C31.7955 16.4443 27.6625 12.75 22.6667 12.75V11.3333H32.5833V21.25H32.4829Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 32.5833C28.1435 32.5833 32.5833 28.1435 32.5833 22.6667V32.5833H22.6667Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22.6667C12.75 27.6625 16.4443 31.7955 21.25 32.4829V32.5833H11.3333V22.6667H12.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 22.6667H0V32.5833H9.91667V22.6667Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6667 34C28.9259 34 34 28.9259 34 22.6667C34 16.4074 28.9259 11.3333 22.6667 11.3333C16.4074 11.3333 11.3333 16.4074 11.3333 22.6667C11.3333 28.9259 16.4074 34 22.6667 34ZM22.6667 32.5833C28.1435 32.5833 32.5833 28.1435 32.5833 22.6667C32.5833 17.1898 28.1435 12.75 22.6667 12.75C17.1898 12.75 12.75 17.1898 12.75 22.6667C12.75 28.1435 17.1898 32.5833 22.6667 32.5833Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 19.8333H24.0833V29.75H21.25V19.8333Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 15.5833H24.0833V18.4167H21.25V15.5833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentInfo);
export default __webpack_public_path__ + "static/media/ExperimentInfo.8935532db02f5d422b59d77f1ab70846.svg";
export { ForwardRef as ReactComponent };